/**
 * Welcome screen (first launch, Graphic/welcome). Shown once to visitors without
 * an account: Get Started → pricing with the sign-up gift; "I already have an
 * account" → sign-in sheet. Layout mirrors the 941×1672 design, positioned in %.
 */
import { navigate } from '../router.js';
import { openSignInSheet } from '../ui/signinSheet.js';
import { authChanged, hasAccount } from '../state/auth.js';

const SEEN_KEY = 'loomia.welcomed';
const IMG = '/img/welcome';

export function welcomeSeen(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) === '1';
  } catch {
    return true; // storage blocked: never trap the user on the welcome screen
  }
}

export function markWelcomeSeen(): void {
  try {
    localStorage.setItem(SEEN_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function renderWelcome(root: HTMLElement): void {
  markWelcomeSeen();
  root.innerHTML = `
    <main class="wl">
      <div class="wl-screen">
        <img class="wl-l wl-bg" src="${IMG}/bg.webp" alt="" decoding="async" />
        <img class="wl-l wl-logo" src="${IMG}/logo.webp" alt="Loomia" />
        <p class="wl-tag">AI for a more<br />beautiful you</p>
        <img class="wl-l wl-head" src="${IMG}/head.webp" alt="Ready to Create?" />
        <img class="wl-l wl-sub" src="${IMG}/sub.webp" alt="Turn your photos into stunning AI stories, edits, and videos." />
        <button class="wl-l wl-btn" type="button" id="wl-start">
          <img src="${IMG}/button_blank.webp" alt="" />
          <span>Get Started
            <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6"/></svg>
          </span>
        </button>
        <button class="wl-link" type="button" id="wl-login">I already have an account</button>
      </div>
    </main>`;

  root.querySelector('#wl-start')?.addEventListener('click', () => navigate('/paywall?from=welcome'));
  root.querySelector('#wl-login')?.addEventListener('click', () => {
    openSignInSheet('Welcome back', 'Enter your email and we’ll send you a sign-in link. No password needed.');
    // Wait for a real account; ignore intermediate auth events.
    const off = authChanged.on(() => {
      if (!root.isConnected) return off();
      if (!hasAccount()) return;
      off();
      navigate('/home');
    });
  });
}
